import { computed } from 'vue';
import { RECOGNITION_AWARD_TYPES } from '@/pages/recognition/constants';

export default function useAwardGivingConfig(program) {
  const companyValues = computed(() => {
    const values = program.value?.properties?.company_values;
    if (!values || !values.length) {
      return [];
    }
    return values.map(v => v.name || v);
  });

  // Open awards are non-monetary, so never offer an amount on one even if a program
  // configured before that rule still carries values the API would now reject.
  const isMonetary = computed(() => program.value?.program_type !== RECOGNITION_AWARD_TYPES.OPEN);

  const awardAmounts = computed(() => {
    const vals = isMonetary.value ? program.value?.properties?.award_value_minor : null;
    if (!vals) {
      return [];
    }
    return Array.isArray(vals) ? vals : [vals];
  });

  const defaultAmountMinor = computed(() => program.value?.properties?.default_award_value_minor || null);

  const maxAwardValueMinor = computed(() =>
    isMonetary.value ? program.value?.properties?.max_award_value_minor ?? null : null,
  );

  // Adjustable mode: no fixed presets but a monetary reward with a cap (mirrors the
  // mobile free-amount mode). The giver types the amount, bounded by the cap.
  const isAdjustableAmount = computed(() => awardAmounts.value.length === 0 && maxAwardValueMinor.value !== null);

  const categories = computed(() => program.value?.properties?.categories || []);

  const categoryRequired = computed(() => Boolean(program.value?.properties?.category_required));

  return {
    companyValues,
    awardAmounts,
    defaultAmountMinor,
    maxAwardValueMinor,
    isAdjustableAmount,
    categories,
    categoryRequired,
  };
}
